import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";

const initialState = {
    appliedOffer: null,
    offerList: [],
    loading: false,
    error: null,
    appliedOfferDetail: {},
    appliedOfferError: null,
    offerApplyLoader: false,
    couponModal: false,
    couponSuccessModal: false,
    showOfferMisMatchModal: false,
    selectedActivePaymentTab: null
};
const baseUrl = process.env.REACT_APP_BASE_URL;

export const fetchOffers = createAsyncThunk(
    "offerSlice/fetchOffers",
    async ({ sessionToken, payload } = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`${baseUrl}/checkout/sessions/${sessionToken}/offers/search`, payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message || "Failed to fetch offers");
        }
    });

export const applyOffer = createAsyncThunk(
    "offerSlice/applyOffer",
    async ({ sessionToken, payload, handleSuccess, handleError, returnValue = true } = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`${baseUrl}/checkout/sessions/${sessionToken}/offers/evaluate`, payload);
            if (handleSuccess) {
                handleSuccess(response)
            }
            let discountAmount = 0
            let codes = []
            response?.data?.evaluatedOffers?.forEach(element => {
                discountAmount += element?.appliedDiscountAmount || 0
                codes.push(element.code)
            });
            if (returnValue) {
                return { response: { ...(response?.data || {}), discountAmount, codes } };
            }
        } catch (error) {
            if (handleError) {
                handleError(error)
            }
            return rejectWithValue(error.response?.data || error.message || "Failed to fetch offers");
        }
    });

export const offerSlice = createSlice({
    name: "offerSlice",
    initialState,
    reducers: {
        setAppliedOffer(state, action) {
            state.appliedOffer = action.payload;
        },
        setAppliedOfferDetails(state) {
            state.appliedOfferDetail = {}
        },
        setCouponModal(state, action) {
            state.couponModal = action.payload
        },
        setSuccessModal(state, action) {
            state.couponSuccessModal = action.payload
        },
        setOfferMisMatchModal(state, action) {
            state.showOfferMisMatchModal = action.payload
        },
        setSelectedActivePaymentTab(state, action) {
            state.selectedActivePaymentTab = action.payload
        }
    },
    extraReducers: (builder) => {

        builder
            .addCase(fetchOffers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOffers.fulfilled, (state, action) => {
                state.offerList = action.payload;

                state.loading = false;
                state.error = null;
            })
            .addCase(fetchOffers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Something went wrong";
            })

            .addCase(applyOffer.pending, (state) => {
                state.offerApplyLoader = true;
                state.appliedOfferError = null;
            })
            .addCase(applyOffer.fulfilled, (state, action) => {
                if (action?.payload?.response) {
                    state.appliedOfferDetail = action.payload.response;
                }
                state.offerApplyLoader = false;
                state.appliedOfferError = null;
            })
            .addCase(applyOffer.rejected, (state, action) => {
                state.offerApplyLoader = false;
                state.appliedOfferError = action.payload || "Something went wrong while applying offer";
            })

    }
});

export const { setAppliedOffer, setAppliedOfferDetails, setCouponModal, setSuccessModal, setOfferMisMatchModal, setSelectedActivePaymentTab } = offerSlice.actions;

export default offerSlice.reducer;


